var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.89209H513V342.892H0V0.89209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 0.89209H204V119.592H0V223.592H204V342.892H308V223.592H513V119.592H308V0.89209Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.6 188.892L394.6 206.192V136.892L368.6 154.192H273.3V58.9922L290.6 32.9922H221.4L238.7 58.9922V154.192H143.4L117.4 136.892V206.192L143.4 188.892H238.7V284.092L221.4 310.092H290.6L273.3 284.092V188.892H368.6Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/GG.07fd47ab25f066953c05f4f89635f278.svg";
export { ForwardRef as ReactComponent };